/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".delete-action[_ngcontent-%COMP%]{color:red;cursor:pointer}.account-list[_ngcontent-%COMP%]{max-height:350px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/accounts.component.scss.shim.ngstyle.js.pre-build-optimizer.js